<template>

  <!-- Packages Start -->
  <div class="section section-padding mt-n10 package-page-padding">
    <div class="container">

      <!-- Section Title Start -->
      <!-- <div class="section-title shape-03 text-center">
        <h2 class="main-title">Organisation / Customized</h2>
      </div> -->
      <!-- Section Title End -->

    </div>
  </div>
  <!-- Packages End -->

  
  <!-- Packages Start -->
  <div class="section section-padding mt-n10 padding-top-0">
    <div class="container">
      <h5><router-link to="/packages" class="btn float-right"><i class="icofont-arrow-left"></i> Go back to All Packages</router-link></h5>
      <br/><br/><br/>

      <div class="contact-wrapper">
        <!-- Section Title Start -->
        <div class="section-title shape-03 text-center">
          <h2 class="main-title">Are you an <span>organization</span> looking for <span>bulk purchases?</span></h2>
          <br />
          <h3 class="title">Fill out the form below, and we'll connect with you for the best deal!</h3>
        </div>
        <!-- Section Title End -->
        <div class="form-wrapper">
          <form id="contact-form"  @submit.prevent="request_pkg">
            <div class="single-form">
              <input type="text" required v-model="form.name" placeholder="Organization Name">
            </div>
            <div class="single-form">
              <input type="email" required v-model="form.email" placeholder="Organization Email">
            </div>
            <div class="single-form">
              <input type="phone" required v-model="form.phone" placeholder="Contact Number">
            </div>
            <div class="single-form">
              <input type="number" required v-model="form.candidates" placeholder="How many candidates do you want subscription for?">
            </div>
            <div class="single-form">
              <input type="number" required v-model="form.assessments" placeholder="How many assessments do you want for each candidate?">
            </div>
            <div class="single-form">
              <input type="number" required v-model="form.questions" placeholder="How many questions do you want for each assessment?" min="1" max="100">
            </div>
            <div class="single-form">
              <textarea v-model="form.message" placeholder="Message" required></textarea>
            </div>
            <p class="form-message"></p>
            <div class="single-form">
              <button class="btn btn-primary btn-hover-dark w-100">
                <span>Request Package</span> 
                <div v-if='loader' class="loader"></div>
                <i v-else class="flaticon-right"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Packages End -->

  <!-- Call to Action Start -->
  <div class="section padding-bottom-50">
    <div class="container">

      <!-- Call to Action Wrapper Start -->
      <div class="call-to-action-wrapper">

        <img class="cat-shape-01 animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">
        <img class="cat-shape-02" src="/assets/images/shape/shape-13.svg" alt="Shape">
        <img class="cat-shape-03 animation-round" src="/assets/images/shape/shape-12.png" alt="Shape">

        <div class="row align-items-center">
          <div class="col-md-6">

            <!-- Section Title Start -->
            <div class="section-title shape-02">
              <h5 class="sub-title">Try for Free!</h5>
              <h2 class="main-title">Sign up for a free trial &amp; start your <span>MCQ prep!</span></h2>
            </div>
            <!-- Section Title End -->

          </div>
          <div class="col-md-6">
            <div class="call-to-action-btn">
              <a class="btn btn-primary btn-hover-dark" href="contact.html">Register Now</a>
            </div>
          </div>
        </div>
      </div>
      <!-- Call to Action Wrapper End -->

    </div>
  </div>
  <!-- Call to Action End -->c

</template>

<script>
import {request_package} from '@/services/packageService';
import {AppConfig} from '@/constants';
export default {
  name: 'RetentionPackage',
  data(){
    return{
      form: {},
      loader: false
    }
  },
  methods: {
      async request_pkg(){
          this.loader = true;
          try{
            if (this.form.questions < 1 || this.form.questions > 100) {
              alert('Number of questions must be between 1 and 100.');
              this.loader = false;
              return;
            }
            // Prepare payload with correct field names
            const payload = {
              name: this.form.name,
              email: this.form.email,
              phone: this.form.phone,
              users: this.form.candidates,        // Map candidates to users
              assessments: this.form.assessments,  // Add assessments
              questions: this.form.questions,      // Add questions
              message: this.form.message,
              to: AppConfig.CONTACT_US_EMAIL
            };
            
            await request_package(payload);
            
            // Show success message
            alert('Request submitted successfully!');
            
            // Clear form
            this.form = {};
          }catch(error){
            console.log('Error:', error);
            alert('Failed to submit request. Please try again.');
          }finally{
            this.loader = false;
          }
      }
  }
};
</script>
<style scoped>
button .loader {
  display: inline-block;
  margin-left: 8px; /* optional spacing between span and loader */
  vertical-align: middle;
}

.loader {
  width: 20px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 4px solid white;
  border-right-color: #309255;
  animation: l2 1s infinite linear;
}
@keyframes l2 {to{transform: rotate(1turn)}}
</style>